import {SupplierModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: SupplierModel = {
  id: '',
  ruc: '',
  direccion: '',
  empresaId: '',
  fechaInicioServicio: '',
  fechaFinServicio: '',
  razonSocial: '',
  nota: '',
  estado: '',
  ...aditionalValues,
}
